var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 18 18"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#101C32","d":"M5.03 3.97a.75.75 0 0 0-1.06 1.06L7.94 9l-3.97 3.97a.75.75 0 1 0 1.06 1.06L9 10.06l3.97 3.97a.75.75 0 1 0 1.06-1.06L10.06 9l3.97-3.97a.75.75 0 0 0-1.06-1.06L9 7.94z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }